import { useState, useEffect } from 'react';
import { TopModalPropsForDisplayQueue } from '@/components/TopModals';
import { ModalBaseWithFlg } from '@/components/ModalBase';
import { QualifiedModalIsOpenAtom } from '@/utility/CommonAtoms';
import { AuthAtoms } from '@/features/login/hoc/AuthAtom';
import { isAdminRoleAtom } from '@/stores/session/UserRoleAtom';
import { useAtom, useAtomValue } from 'jotai';
import { useGetMember } from '@/apis/core/user';
import { useNavigate } from 'react-router-dom';
import styled from '@emotion/styled';
import ImageDoneIcon from '@/assets/top/icon_done.png';

const TitleH2 = styled.h2<{ isSmallScreen?: boolean }>`
  font-size: ${(props) => (props.isSmallScreen ? '20px' : '24px')};
  align-items: center;
  display: flex;
  justify-content: flex-start;
  margin-bottom: 15px;

  color: rgb(234 85 4 / var(--tw-text-opacity));
  &:before {
    content: '';
    width: 3px;
    height: ${(props) => (props.isSmallScreen ? '20px' : '24px')};
    margin-right: 10px;
    background: rgb(234 85 4 / var(--tw-text-opacity));
    transform: rotate(-30deg);
  }

  &:after {
    content: '';
    width: 3px;
    height: ${(props) => (props.isSmallScreen ? '20px' : '24px')};
    margin-left: 10px;
    background: rgb(234 85 4 / var(--tw-text-opacity));
    transform: rotate(30deg);
  }
`;

const CheckLi = styled.li`
  display: flex;
  &:before {
    content: '';
    background: url(${ImageDoneIcon}) no-repeat;
    background-size: contain;
    height: 16px;
    width: 24px;
    margin-top: 5px;
  }
`;

const StrongText = styled.span`
  font-weight: bolder;
`;

const QualifiedModal = (props: TopModalPropsForDisplayQueue) => {
  const isAuth = useAtomValue(AuthAtoms.isAuth);
  const isOperator = useAtomValue(isAdminRoleAtom);
  const getMember = useGetMember(undefined, false, { enabled: isAuth });
  const [qualifiedModalIsOpen, setQualifiedModalIsOpen] = useAtom(QualifiedModalIsOpenAtom);
  const navigate = useNavigate();
  const [isSmallScreen, setIsSmallScreen] = useState(window.matchMedia('(max-width: 767px)').matches);

  useEffect(() => {
    if (!isOperator && isAuth && qualifiedModalIsOpen === 'OPEN') {
      if (
        getMember.isSuccess &&
        ((!!getMember.data.existingStoreCount &&
          !!getMember.data.openingStatus &&
          !!getMember.data.openingFunds &&
          !!getMember.data.ownFunds &&
          !!getMember.data.openingIndustryType &&
          !!getMember.data.openingPrefecture) ||
          !getMember.data?.willOpenFlg)
      ) {
        setQualifiedModalIsOpen('CLOSE');
        props.goNext();
      }
    }
  }, [isOperator, isAuth, qualifiedModalIsOpen, getMember.isSuccess]);

  const handleResize = () => {
    setIsSmallScreen(window.matchMedia('(max-width: 767px)').matches);
  };

  useEffect(() => {
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);
  return (
    <>
      {getMember.isSuccess && (
        <ModalBaseWithFlg
          modalOpenAtom={QualifiedModalIsOpenAtom}
          modalClass="QualifiedModal md:!w-auto max-w-[770px] xl:min-w-[550px] "
          backgroundModalClose="CLOSE"
          closeEvent={() => props.goNext()}
        >
          <div className="mt-[-20px] md:mt-[-45px] text-left">
            <TitleH2 isSmallScreen={isSmallScreen}>開業準備をもっとスムーズに</TitleH2>
            <p className="text-xl">
              新たに<StrongText>「開業の詳細情報」</StrongText> を登録できるようになりました！
            </p>
            <ul>
              <CheckLi>出店予定時期</CheckLi>
              <CheckLi>開業総予算</CheckLi>
              <CheckLi>業種 など…</CheckLi>
            </ul>
            <p className="text-xl">
              登録いただくと、今後あなたに最適な支援サービスをご案内します！
              <br />
              今すぐ情報を登録して、スムーズな開業準備を進めましょう
            </p>
            <div className="mt-[15px]">
              <button
                onClick={() => {
                  setQualifiedModalIsOpen('CLOSE');
                  navigate('mypage/member?editOpeningInfo=1');
                }}
                className="btnModalGreen md:w-auto w-full"
              >
                今すぐ登録する{isSmallScreen && <br />}（マイページへ移動）
              </button>
            </div>
          </div>
        </ModalBaseWithFlg>
      )}
    </>
  );
};

export default QualifiedModal;
